const Styles = {
    heroHeadText: 
    
        "text-violet-800 lg:text-[80px] sm:text-[60px] xs:text-[40px] text-[40px] lg:leading-[98px] mt-2",
        heroSubText: "text-violet-700 font-medium lg:text-[30px] sm:text-[26px] xs:text-[20px] text-[16px] lg:leading-[40px]",
        sectionHeadText: "text-violet-600 pl-8 md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]",
        sectionSubText: "sm:text-[18px] text-violet-600 text-[14px] uppercase tracking-wider",
        sectionText: "mt-4 pl-8 text-orange-500 text-[17px] leading-[30px] max-w-3xl",
    
};

export { Styles };
